/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import ISectionApiClient from './contracts'
import { ISectionArticleList, ISectionArticle } from '../SectionStateManager/contracts'
import { injectable } from 'inversify'
import { injectProperty } from '../../configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../middleware/UserSessionMiddleware/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import axios from 'axios'
import { isObject } from 'util'
import { SectionArticleQuery } from './SectionQuery'
import { IApiClient } from '../ApiClient/IApiClient'
import { ErrorHelper } from '../../utils/ErrorHelper'

@injectable()
export class SectionApiClient implements ISectionApiClient {
	@injectProperty('IApiClient')
	private readonly apiClient!: IApiClient

	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	getSectionArticles(productCode: string, sectionName: string): Promise<ISectionArticleList> {
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`
		return new Promise<ISectionArticleList>((resolve, reject) => {
			this.userSessionMiddleware.loadSessionJwt(false).then(x =>
				axios
					.get(url, {
						params: {
							query: SectionArticleQuery(productCode, sectionName),
						},
						headers: {
							Authorization: `Bearer ${x}`,
						},
					})
					.then(response => {
						const formattedResults = { items: [], total: 0 } as ISectionArticleList
						if (response.data.data.aBILITYPage.length > 0) {
							const data = response.data.data.aBILITYPage
							data.map((item: any, index: number) => {
								if (item.sectionTags != null) {
									if (item.sectionTags.termContentItems.findIndex((x: any) => x.contentItemId === sectionName) !== -1) {
										const sectionArticleResult = {
											sectionArticleId: item.contentItemId,
											sectionArticleName: item.displayText,
											sectionArticlePath: item.path,//'/content/' + item.contentItemId,
											productCode: item.productContent.productName,
											sectionName:
												item.sectionTags.termContentItems[item.sectionTags.termContentItems.findIndex((x: any) => x.contentItemId === sectionName)].displayText,
											IsPdf: false,
										} as ISectionArticle
										formattedResults.items.push(sectionArticleResult)
									}
								}
							})
							formattedResults.total = response.data.data.aBILITYPage.length

							//resolve(formattedResults)
						}

						if (response.data.data.pdf && response.data.data.pdf.length > 0) {
							//const pdfData = response.data.data.aBILITYPage
							response.data.data.pdf.map((item: any, index: number) => {
								if (item.sectionTags != null) {
									if (item.sectionTags.termContentItems.findIndex((x: any) => x.contentItemId === sectionName) !== -1) {
										const sectionArticleResult = {
											sectionArticleId: item.contentItemId,
											sectionArticleName: item.displayText,
											sectionArticlePath: item.pdfDocument.relativePdfPath,
											productCode: item.productContent.productName,
											sectionName:
												item.sectionTags.termContentItems[item.sectionTags.termContentItems.findIndex((x: any) => x.contentItemId === sectionName)].displayText,
											IsPdf: true,
										} as ISectionArticle
										formattedResults.items.push(sectionArticleResult)
									}
								}
							})
							formattedResults.total = formattedResults.total + response.data.data.pdf.length
						}

						if (formattedResults.total > 0) {
							const articleResults = { items: [], total: 0 } as ISectionArticleList
							articleResults.items = formattedResults.items.sort((a, b) => (a.sectionArticleName.toLowerCase() < b.sectionArticleName.toLowerCase() ? -1 : 1))
							articleResults.total = formattedResults.total
							resolve(articleResults)
						}
						else
							reject(`Help page with path "${sectionName}" not found`)
					})
					.catch(error => {
						if (error.response !== null && typeof error.response !== 'undefined' && error.response.status === 401)
							ErrorHelper.handleApiError(error)
						else
							reject(error)
					})
			)
		})
	}
}
